// index.js - WEB
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
 //import { BrowserRouter as Router  } from "react-router-dom";
//import {HashRouter as Router } from "react-router-dom";

import registerServiceWorker from "./web/componentss/registerServiceWorker";
import './icons';
//import {initializeFirebase} from "./firebase/web/push-notification";
ReactDOM.render(
//{/*  <Router >*/}
    <App />
//{/*  </Router>*/}
    ,
  document.getElementById("root")
);
//initializeFirebase();

registerServiceWorker();
